var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormulateForm",
        { ref: "form", attrs: { name: "formStore" } },
        [
          _c(
            "b-card-actions",
            {
              ref: "main-card",
              attrs: {
                "no-actions": "",
                "show-loading": _vm.loading || _vm.busy,
                title: _vm.$t("Dados Cadastrais"),
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("e-company-combo", {
                        attrs: {
                          id: "company-id",
                          name: "company-id",
                          required: true,
                          label: _vm.$t("Empresa"),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.loadCompanyData(_vm.store.companyId)
                          },
                        },
                        model: {
                          value: _vm.store.companyId,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "companyId", $$v)
                          },
                          expression: "store.companyId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "1" } },
                    [
                      _c("FormulateInput", {
                        staticClass: "required",
                        attrs: {
                          id: "store-id",
                          name: "id",
                          label: _vm.$t("Id"),
                          type: _vm.isEdition ? "label" : "number",
                          validation: "required",
                        },
                        model: {
                          value: _vm.store.id,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "id", $$v)
                          },
                          expression: "store.id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        staticClass: "required",
                        attrs: {
                          id: "identification",
                          name: "identification",
                          label: _vm.$t("Identificação"),
                          placeholder: "M01, F01, Q01, etc.",
                          type: "text",
                          validation: "required",
                        },
                        model: {
                          value: _vm.store.identification,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "identification", $$v)
                          },
                          expression: "store.identification",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "company-name",
                          name: "companyName",
                          label: _vm.$t("Razão Social"),
                          type: "label",
                          instruction: _vm.$t("Herdado da empresa selecionada"),
                        },
                        model: {
                          value: _vm.store.companyName,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "companyName", $$v)
                          },
                          expression: "store.companyName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        staticClass: "required",
                        attrs: {
                          id: "trading-name",
                          name: "tradingName",
                          type: "text",
                          label: _vm.$t("Nome Fantasia"),
                          validation: "required",
                        },
                        model: {
                          value: _vm.store.tradingName,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "tradingName", $$v)
                          },
                          expression: "store.tradingName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: false,
                          expression: "false",
                        },
                      ],
                      attrs: { md: "3" },
                    },
                    [
                      _c("e-store-combo", {
                        attrs: {
                          id: "order-store_id",
                          name: "headquartersStoreId",
                          required: false,
                          label: _vm.$t("Matriz"),
                        },
                        model: {
                          value: _vm.store.headquartersStoreId,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "headquartersStoreId", $$v)
                          },
                          expression: "store.headquartersStoreId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        staticClass: "required",
                        attrs: {
                          id: "type",
                          name: "type",
                          type:
                            _vm.isEdition && _vm.store.type === "Kiosk"
                              ? "label"
                              : "vue-select",
                          validation: "required",
                          label: _vm.$t("Tipo"),
                          options: _vm.storeTypes(),
                          placeholder: _vm.$t("Selecione"),
                        },
                        model: {
                          value: _vm.store.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "type", $$v)
                          },
                          expression: "store.type",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "region",
                          name: "region",
                          type: "label",
                          label: _vm.$t("Região"),
                        },
                        model: {
                          value: _vm.store.region,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "region", $$v)
                          },
                          expression: "store.region",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        staticClass: "required",
                        attrs: {
                          id: "businessModel",
                          name: "businessModel",
                          type: "vue-select",
                          validation: "required",
                          label: _vm.$t("Modelo"),
                          options: _vm.storeBusinessModels(),
                          placeholder: _vm.$t("Selecione"),
                        },
                        model: {
                          value: _vm.store.businessModel,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "businessModel", $$v)
                          },
                          expression: "store.businessModel",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        staticClass: "required",
                        attrs: {
                          id: "headId",
                          name: "headId",
                          type: "vue-select",
                          validation: "required",
                          label: _vm.$t("Head"),
                          options: _vm.headOptions,
                          placeholder: _vm.$t("Selecione"),
                        },
                        model: {
                          value: _vm.store.headId,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "headId", $$v)
                          },
                          expression: "store.headId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "directorId",
                          name: "directorId",
                          type: "vue-select",
                          label: _vm.$t("Diretor"),
                          options: _vm.directorOptions,
                          placeholder: _vm.$t("Selecione"),
                        },
                        model: {
                          value: _vm.store.directorId,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "directorId", $$v)
                          },
                          expression: "store.directorId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "directorCommercialId",
                          name: "directorCommercialId",
                          type: "vue-select",
                          label: _vm.$t("Diretor Comercial"),
                          options: _vm.directorCommercialOptions,
                          placeholder: _vm.$t("Selecione"),
                        },
                        model: {
                          value: _vm.store.directorCommercialId,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "directorCommercialId", $$v)
                          },
                          expression: "store.directorCommercialId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        staticClass: "required",
                        attrs: {
                          id: "invoice-serie-number",
                          name: "invoiceSerialNumber",
                          type: "number",
                          label: _vm.$t("Série da NFe"),
                          instruction: _vm.$t(
                            "Série utilizado para emissão da NF-e"
                          ),
                          validation: "required",
                        },
                        model: {
                          value: _vm.store.invoiceSerialNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "invoiceSerialNumber", $$v)
                          },
                          expression: "store.invoiceSerialNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "cnpj",
                          name: "cnpj",
                          filter: "cpfCnpj",
                          label: _vm.$t("CNPJ"),
                          type: "label",
                          instruction: _vm.$t("Herdado da empresa selecionada"),
                        },
                        model: {
                          value: _vm.store.cnpj,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "cnpj", $$v)
                          },
                          expression: "store.cnpj",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        staticClass: "required",
                        attrs: {
                          id: "state-registration",
                          name: "stateRegistration",
                          maxlength: "20",
                          label: _vm.$t("Inscrição Estadual"),
                          type: "label",
                          instruction: _vm.$t("Herdado da empresa selecionada"),
                        },
                        model: {
                          value: _vm.store.stateRegistration,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "stateRegistration", $$v)
                          },
                          expression: "store.stateRegistration",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "state-registration-of-tax-substitute",
                          name: "stateRegistrationOfTaxSubstitute",
                          maxlength: "20",
                          label: _vm.$t("I.E. do Substituto Tributário"),
                          type: "label",
                          instruction: _vm.$t("Herdado da empresa selecionada"),
                        },
                        model: {
                          value: _vm.store.stateRegistrationOfTaxSubstitute,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.store,
                              "stateRegistrationOfTaxSubstitute",
                              $$v
                            )
                          },
                          expression: "store.stateRegistrationOfTaxSubstitute",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "municipal-inscription",
                          name: "municipalInscription",
                          maxlength: "20",
                          label: _vm.$t("Inscrição Municipal"),
                          type: "label",
                          instruction: _vm.$t("Herdado da empresa selecionada"),
                        },
                        model: {
                          value: _vm.store.municipalInscription,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "municipalInscription", $$v)
                          },
                          expression: "store.municipalInscription",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "investors",
                          name: "investors",
                          type: "vue-select",
                          multiple: "",
                          label: _vm.$t("Investidores"),
                          options: _vm.investorsOptions,
                          placeholder: _vm.$t("Selecione"),
                        },
                        model: {
                          value: _vm.store.investors,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "investors", $$v)
                          },
                          expression: "store.investors",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        staticClass: "required",
                        attrs: {
                          id: "email",
                          name: "email",
                          type: "text",
                          label: _vm.$t("E-mail"),
                          validation: "required",
                        },
                        model: {
                          value: _vm.store.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "email", $$v)
                          },
                          expression: "store.email",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "1" } },
                    [
                      _c("p", { staticClass: "h6" }, [_vm._v(" Ativo? ")]),
                      _c("e-status-badge", {
                        attrs: { status: !!_vm.store.active, type: "yesNo" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tabs",
            { staticClass: "mt-1" },
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("Endereço"), active: "" } },
                [
                  _c("e-address", {
                    ref: "address",
                    attrs: {
                      required: false,
                      "show-map": true,
                      "show-lat-lng": true,
                      "required-lat-lng": true,
                      "show-loading": _vm.loading || _vm.busy,
                    },
                    model: {
                      value: _vm.store.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.store, "address", $$v)
                      },
                      expression: "store.address",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("Telefones") } },
                [
                  _c(
                    "b-card-actions",
                    {
                      ref: "main-card",
                      attrs: {
                        "no-actions": "",
                        "show-loading": _vm.loading || _vm.busy,
                        title: _vm.$t("Telefones"),
                      },
                    },
                    [
                      _c("FormulateInput", {
                        ref: "telephoneGroup",
                        attrs: {
                          name: "telephones",
                          type: "group",
                          "error-behavior": "live",
                          repeatable: true,
                          "add-label": _vm.$t("Adicionar Telefone"),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var index = ref.index
                              return [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { md: "5" } },
                                      [
                                        _c("FormulateInput", {
                                          staticClass: "required",
                                          attrs: {
                                            id: "store-telephone-type-" + index,
                                            type: "vue-select",
                                            name: "type",
                                            label: _vm.$t("Tipo"),
                                            options: _vm.telephoneTypes(),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { md: "7" } },
                                      [
                                        _c("FormulateInput", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: [
                                                "(##) ####-####",
                                                "(##) #####-####",
                                              ],
                                              expression:
                                                "['(##) ####-####', '(##) #####-####']",
                                            },
                                          ],
                                          staticClass: "required",
                                          attrs: {
                                            id:
                                              "store-telephone-number-" + index,
                                            type: "text",
                                            name: "number",
                                            validation: "optional|min:14",
                                            maxlength: "15",
                                            instruction: _vm.$t(
                                              "Exemplo: (99) 99999-9999"
                                            ),
                                            label: _vm.$t("Telefone"),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.store.telephones,
                          callback: function ($$v) {
                            _vm.$set(_vm.store, "telephones", $$v)
                          },
                          expression: "store.telephones",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("Delivery") } },
                [
                  _c(
                    "b-card-actions",
                    {
                      attrs: {
                        "no-actions": "",
                        "show-loading": _vm.loading || _vm.busy,
                        title: _vm.$t("Delivery"),
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "store-delivery",
                                  name: "delivery",
                                  type: "switch",
                                  label: _vm.$t("Oferece Delivery?"),
                                },
                                model: {
                                  value: _vm.store.delivery,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.store, "delivery", $$v)
                                  },
                                  expression: "store.delivery",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c("FormulateInput", {
                                class: _vm.store.delivery ? "required" : "",
                                attrs: {
                                  id: "email-delivery",
                                  name: "emailDelivery",
                                  type: "text",
                                  label: _vm.$t("E-mail Delivery"),
                                  instruction: _vm.$t(
                                    "E-mail usado para o processo de entregas"
                                  ),
                                  validation: _vm.store.delivery
                                    ? "required"
                                    : "",
                                },
                                model: {
                                  value: _vm.store.emailDelivery,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.store, "emailDelivery", $$v)
                                  },
                                  expression: "store.emailDelivery",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c("FormulateInput", {
                                class: _vm.store.delivery ? "required" : "",
                                attrs: {
                                  id: "max-schedule",
                                  name: "maxScheduleDays",
                                  type: "text-number",
                                  label: _vm.$t("Qtd. dias p/ entrega"),
                                  instruction: _vm.$t(
                                    "Quantidade máxima de dias para entrega de pedidos."
                                  ),
                                  validation: _vm.store.delivery
                                    ? "required"
                                    : "",
                                },
                                model: {
                                  value: _vm.store.maxScheduleDays,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.store, "maxScheduleDays", $$v)
                                  },
                                  expression: "store.maxScheduleDays",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c("FormulateInput", {
                                staticClass: "required",
                                attrs: {
                                  id: "min-delivery-schedule-minutes",
                                  name: "minDeliveryScheduleMinutes",
                                  type: "number",
                                  min: "1",
                                  max: "1440",
                                  step: "1",
                                  validation: "required|number|min:1|max:1440",
                                  "validation-messages": {
                                    required: _vm.$t(
                                      "STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE"
                                    ),
                                    number: _vm.$t(
                                      "STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE"
                                    ),
                                    min: _vm.$t(
                                      "STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE"
                                    ),
                                    max: _vm.$t(
                                      "STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE"
                                    ),
                                  },
                                  label: _vm.$t("Tempo mínimo de entrega"),
                                  instruction: _vm.$t(
                                    "Tempo, em minutos, entre o pedido e a entrega. Valida o agendamento e define a janela do acionamento automático."
                                  ),
                                },
                                model: {
                                  value: _vm.store.minDeliveryScheduleMinutes,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "minDeliveryScheduleMinutes",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "store.minDeliveryScheduleMinutes",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "auto-delivery-enabled",
                                  name: "autoDeliveryEnabled",
                                  type: "switch",
                                  label: _vm.$t("Delivery automático"),
                                  instruction: _vm.$t(
                                    "Quando habilitado, os pedidos online da loja são despachados automaticamente aos fornecedores de entrega."
                                  ),
                                },
                                model: {
                                  value: _vm.store.autoDeliveryEnabled,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "autoDeliveryEnabled",
                                      $$v
                                    )
                                  },
                                  expression: "store.autoDeliveryEnabled",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "lending-schedule-enabled",
                                  name: "lendingScheduleEnabled",
                                  type: "switch",
                                  label: _vm.$t(
                                    "Agendamento de chope/comodato"
                                  ),
                                  instruction: _vm.$t(
                                    "Quando habilitado, pedidos de comodato com entrega escolhem o horário pela agenda de instalação (tempo de instalação da loja)."
                                  ),
                                },
                                model: {
                                  value: _vm.store.lendingScheduleEnabled,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "lendingScheduleEnabled",
                                      $$v
                                    )
                                  },
                                  expression: "store.lendingScheduleEnabled",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c("FormulateInput", {
                                staticClass: "required",
                                attrs: {
                                  id: "lending-installation-minutes",
                                  name: "lendingInstallationMinutes",
                                  type: "number",
                                  min: "15",
                                  max: "480",
                                  step: "5",
                                  validation:
                                    "required|number|min:15|max:480|multipleOf5",
                                  "validation-messages": {
                                    required: _vm.$t(
                                      "STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES"
                                    ),
                                    number: _vm.$t(
                                      "STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES"
                                    ),
                                    min: _vm.$t(
                                      "STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES"
                                    ),
                                    max: _vm.$t(
                                      "STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES"
                                    ),
                                    multipleOf5: _vm.$t(
                                      "STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES"
                                    ),
                                  },
                                  "validation-rules": {
                                    multipleOf5: _vm.multipleOf5,
                                  },
                                  label: _vm.$t(
                                    "Tempo de instalação do comodato"
                                  ),
                                  instruction: _vm.$t(
                                    "Tempo, em minutos, de uma entrega de chope/comodato. Define o tamanho dos horários da agenda de instalação."
                                  ),
                                },
                                model: {
                                  value: _vm.store.lendingInstallationMinutes,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "lendingInstallationMinutes",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "store.lendingInstallationMinutes",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "motoboy-enabled",
                                  name: "motoboyEnabled",
                                  type: "switch",
                                  label: _vm.$t("Utiliza Motoboys"),
                                  instruction: _vm.$t(
                                    "Quando desabilitado, o painel de delivery não exibe a seção de Motoboys nem permite designar Motoboy aos pedidos da loja."
                                  ),
                                },
                                model: {
                                  value: _vm.store.motoboyEnabled,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.store, "motoboyEnabled", $$v)
                                  },
                                  expression: "store.motoboyEnabled",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c("FormulateInput", {
                                staticClass: "required",
                                attrs: {
                                  id: "motoboy-assignment-time-limit-minutes",
                                  name: "motoboyAssignmentTimeLimitMinutes",
                                  type: "number",
                                  min: "1",
                                  max: "120",
                                  step: "1",
                                  validation: "required|number|min:1|max:120",
                                  "validation-messages": {
                                    required: _vm.$t(
                                      "STORE.VALIDATION_ERROR.MOTOBOY_ASSIGNMENT_TIME_LIMIT_OUT_OF_RANGE"
                                    ),
                                    number: _vm.$t(
                                      "STORE.VALIDATION_ERROR.MOTOBOY_ASSIGNMENT_TIME_LIMIT_OUT_OF_RANGE"
                                    ),
                                    min: _vm.$t(
                                      "STORE.VALIDATION_ERROR.MOTOBOY_ASSIGNMENT_TIME_LIMIT_OUT_OF_RANGE"
                                    ),
                                    max: _vm.$t(
                                      "STORE.VALIDATION_ERROR.MOTOBOY_ASSIGNMENT_TIME_LIMIT_OUT_OF_RANGE"
                                    ),
                                  },
                                  label: _vm.$t(
                                    "Tempo limite para atribuir Motoboy"
                                  ),
                                  instruction: _vm.$t(
                                    "Tempo, em minutos, para atribuir um Motoboy antes do acionamento automático."
                                  ),
                                },
                                model: {
                                  value:
                                    _vm.store.motoboyAssignmentTimeLimitMinutes,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "motoboyAssignmentTimeLimitMinutes",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "store.motoboyAssignmentTimeLimitMinutes",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "deliveryType",
                                  name: "deliveryType",
                                  type: "vue-select",
                                  instructions: [
                                    {
                                      text: _vm.$t(
                                        "Tipo de entregas que a loja realiza"
                                      ),
                                    },
                                    {
                                      text: _vm.$t(
                                        "Cidade: realiza entregas na cidade inteira."
                                      ),
                                    },
                                    {
                                      text: _vm.$t(
                                        "Polígono: realiza entregas dentro de uma determinada área da cidade."
                                      ),
                                    },
                                  ],
                                  label: _vm.$t("Tipo do Delivery"),
                                  options: _vm.storeDeliveryTypes(),
                                  placeholder: _vm.$t("Selecione"),
                                },
                                model: {
                                  value: _vm.store.deliveryType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.store, "deliveryType", $$v)
                                  },
                                  expression: "store.deliveryType",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "store-delivery-others-cities",
                                  name: "deliveryOthersCities",
                                  type: "switch",
                                  instruction: _vm.$t(
                                    "Permite adicionar outras cidades que a loja poderá realizar entrega."
                                  ),
                                  label: _vm.$t("Entrega em outras cidades?"),
                                },
                                model: {
                                  value: _vm.store.deliveryOthersCities,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "deliveryOthersCities",
                                      $$v
                                    )
                                  },
                                  expression: "store.deliveryOthersCities",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "store-delivery-send-lat-lng",
                                  name: "sendLatLngToDeliverySuppliers",
                                  type: "switch",
                                  instruction: _vm.$t(
                                    "Quando selecionado, o sistema envia Lat/Lng para realizar os pedidos aos fornecedores de entrega terceirizados."
                                  ),
                                  label: _vm.$t("Enviar Lat/Lng?"),
                                },
                                model: {
                                  value:
                                    _vm.store.sendLatLngToDeliverySuppliers,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "sendLatLngToDeliverySuppliers",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "store.sendLatLngToDeliverySuppliers",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "12" } }, [
                            _c("hr"),
                            _c("h6", { staticClass: "mb-1" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("Fornecedores de Delivery")) +
                                  " "
                              ),
                            ]),
                            _c("p", { staticClass: "text-muted" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "Fornecedores terceirizados que podem realizar as entregas desta loja. O fornecedor padrão é o utilizado no acionamento automático."
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c(
                            "b-col",
                            { attrs: { md: "5" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "store-delivery-supplier-to-add",
                                  type: "vue-select",
                                  label: _vm.$t("Fornecedor"),
                                  placeholder: _vm.$t("Selecione"),
                                  options: _vm.availableDeliverySupplierOptions,
                                },
                                model: {
                                  value: _vm.deliverySupplierToAdd,
                                  callback: function ($$v) {
                                    _vm.deliverySupplierToAdd = $$v
                                  },
                                  expression: "deliverySupplierToAdd",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex align-items-center",
                              attrs: { md: "3" },
                            },
                            [
                              _c("e-button", {
                                attrs: {
                                  variant: "primary",
                                  text: _vm.$t("Adicionar Fornecedor"),
                                },
                                on: { click: _vm.onAddDeliverySupplier },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c("b-table", {
                                staticClass: "bordered",
                                attrs: {
                                  id: "store-delivery-suppliers-table",
                                  responsive: "",
                                  striped: "",
                                  "show-empty": "",
                                  "empty-text": _vm.getEmptyTableAddMessage(
                                    _vm.$t("Fornecedor de delivery"),
                                    "male"
                                  ),
                                  items: _vm.getStoreDeliverySuppliers,
                                  fields: _vm.deliverySupplierFields,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "cell(actions)",
                                    fn: function (row) {
                                      return [
                                        _c("e-grid-actions", {
                                          attrs: {
                                            "show-update": false,
                                            "show-delete": true,
                                          },
                                          on: {
                                            delete: function ($event) {
                                              return _vm.onRemoveDeliverySupplier(
                                                row.item
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(supplier)",
                                    fn: function (row) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.deliverySupplierLabel[
                                                row.item.supplier
                                              ] || row.item.supplier
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(isDefault)",
                                    fn: function (row) {
                                      return [
                                        _c("FormulateInput", {
                                          attrs: {
                                            id:
                                              "store-delivery-supplier-default-" +
                                              row.index,
                                            value: row.item.isDefault,
                                            type: "switch",
                                            name: "isDefault-" + row.index,
                                            label: "",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onSetDefaultDeliverySupplier(
                                                row.item,
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.store.deliveryOthersCities
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex justify-content-end mb-1",
                                  attrs: { md: "12" },
                                },
                                [
                                  _c("e-button", {
                                    attrs: {
                                      variant: "primary",
                                      text: _vm.$t("Adicionar Cidade"),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onShowDeliveryLocationSidebar()
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c("b-table", {
                                    staticClass: "bordered",
                                    attrs: {
                                      id: "stores-other-cities-table",
                                      responsive: "",
                                      striped: "",
                                      "show-empty": "",
                                      "empty-text": _vm.getEmptyTableAddMessage(
                                        _vm.$tc("ADDRESS.CITY_NAME"),
                                        "female"
                                      ),
                                      items: _vm.getStoreDeliveryLocations,
                                      fields: _vm.deliveryLocationFields,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "cell(actions)",
                                          fn: function (row) {
                                            return [
                                              _c("e-grid-actions", {
                                                attrs: {
                                                  "show-update": false,
                                                  "show-delete": true,
                                                },
                                                on: {
                                                  delete: function ($event) {
                                                    return _vm.onRemoveDeliveryLocation(
                                                      row.item
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4041282574
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.store.deliveryType ===
                      _vm.storeDeliveryTypesEnum.POLYGON
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "mb-1", attrs: { md: "12" } },
                                [
                                  _c("p", { staticClass: "mb-1" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "Defina o polígono de entrega da loja importando uma planilha (.csv) no formato WKT (item POLYGON) ou desenhando diretamente no mapa. Arraste os pontos para ajustar."
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center flex-wrap",
                                    },
                                    [
                                      _c("e-button", {
                                        attrs: {
                                          variant: "primary",
                                          text: _vm.$t(
                                            "Importar planilha de polígono"
                                          ),
                                        },
                                        on: {
                                          click: _vm.importPolygonSpreadsheet,
                                        },
                                      }),
                                      _c("e-button", {
                                        staticClass: "ml-1",
                                        attrs: {
                                          variant: _vm.isDrawingPolygon
                                            ? "warning"
                                            : "primary",
                                          text: _vm.isDrawingPolygon
                                            ? _vm.$t("Concluir desenho")
                                            : _vm.$t("Desenhar polígono"),
                                        },
                                        on: { click: _vm.toggleDrawPolygon },
                                      }),
                                      _vm.polygonPaths.length
                                        ? _c("e-button", {
                                            staticClass: "ml-1",
                                            attrs: {
                                              variant: "danger",
                                              text: _vm.$t("Remover polígono"),
                                            },
                                            on: { click: _vm.clearPolygon },
                                          })
                                        : _vm._e(),
                                      _vm.polygonPaths.length
                                        ? _c("span", { staticClass: "ml-1" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.polygonPaths.length
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.$t("pontos carregados")
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.isDrawingPolygon
                                    ? _c(
                                        "small",
                                        {
                                          staticClass:
                                            "text-primary d-block mt-1",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  'Clique no mapa para adicionar os pontos e clique em "Concluir desenho" ao finalizar.'
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c("GmapMap", {
                                    ref: "polygonMapRef",
                                    staticStyle: {
                                      width: "100%",
                                      height: "500px",
                                    },
                                    attrs: {
                                      center: _vm.polygonMapCenter,
                                      zoom: 11,
                                      "map-type-id": "roadmap",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("Loja Virtual") } },
                [
                  _c(
                    "b-card-actions",
                    {
                      ref: "main-card",
                      attrs: {
                        "no-actions": "",
                        "show-loading": _vm.loading || _vm.busy,
                        title: _vm.$t("Loja Virtual"),
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "active-online",
                                  name: "activeOnline",
                                  type: "switch",
                                  label: _vm.$t("Venda no Site"),
                                  instruction: _vm.$t(
                                    "Quando habilitado, a loja estará disponível para venda no site e no app"
                                  ),
                                },
                                model: {
                                  value: _vm.store.activeOnline,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.store, "activeOnline", $$v)
                                  },
                                  expression: "store.activeOnline",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-card",
                        {
                          staticClass: "bg-light-gray",
                          attrs: { title: _vm.$t("App B2C") },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "max-product-items-sell",
                                      name: "maxProductItemsSell",
                                      type: "number",
                                      label: _vm.$t("Qtd. Máxima de itens"),
                                      instruction: _vm.$t(
                                        "Indica quantos itens do mesmo produto a loja pode vender nos canais digitais B2C"
                                      ),
                                    },
                                    model: {
                                      value: _vm.store.maxProductItemsSell,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store,
                                          "maxProductItemsSell",
                                          $$v
                                        )
                                      },
                                      expression: "store.maxProductItemsSell",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "max-order-value",
                                      name: "maxOrderValue",
                                      type: "text-number",
                                      currency: "R$",
                                      precision: 2,
                                      label: _vm.$t("Valor máx. de venda"),
                                      instruction: _vm.$t(
                                        "Valor máximo permitido para uma venda"
                                      ),
                                    },
                                    model: {
                                      value: _vm.store.maxOrderValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store,
                                          "maxOrderValue",
                                          $$v
                                        )
                                      },
                                      expression: "store.maxOrderValue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-pix",
                                      name: "onlinePaymentPix",
                                      type: "switch",
                                      label: _vm.$t("Pagto Pix (online)"),
                                      instruction: _vm.$t(
                                        "Quando habilitado, a loja aceitará pagamento via pix no site e no app"
                                      ),
                                    },
                                    model: {
                                      value: _vm.store.onlinePaymentConfig.pix,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "pix",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.pix",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-credit",
                                      name: "onlinePaymentCredit",
                                      type: "switch",
                                      label: _vm.$t("Pagto Crédito (online)"),
                                      instruction: _vm.$t(
                                        "Quando habilitado, a loja aceitará pagamento via cartão de crédito no site e no app"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.store.onlinePaymentConfig.credit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "credit",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.credit",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-wallet",
                                      name: "onlinePaymentWallet",
                                      type: "switch",
                                      label: _vm.$t("Pagto Wallet (online)"),
                                      instruction: _vm.$t(
                                        "Quando habilitado, a loja aceitará pagamento via wallet no site e no app"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.store.onlinePaymentConfig.wallet,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "wallet",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.wallet",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-cash",
                                      name: "onlinePaymentCash",
                                      type: "switch",
                                      label: _vm.$t(
                                        "Pagto Dinheiro (na entrega)"
                                      ),
                                      instruction: _vm.$t(
                                        "Quando habilitado, a loja aceitará pagamentos em dinheiro na entrega de pedidos feitos no site e app"
                                      ),
                                    },
                                    model: {
                                      value: _vm.store.onlinePaymentConfig.cash,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "cash",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.cash",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-pickup",
                                      name: "onlinePaymentPayOnPickup",
                                      type: "switch",
                                      label: _vm.$t(
                                        "Pagto Cartão (na entrega)"
                                      ),
                                      instruction: _vm.$t(
                                        "Quando habilitado, a loja aceitará pagamentos em cartão de crédito/débito na entrega de pedidos feitos no site e app"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.store.onlinePaymentConfig
                                          .payOnPickup,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "payOnPickup",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.payOnPickup",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-chat-enabled",
                                      name: "onlineChatEnabled",
                                      type: "switch",
                                      label: _vm.$t("Chat ativo"),
                                      instruction: _vm.$t(
                                        "Quando habilitado, a loja poderá ser acionada pelos clientes via chat no app"
                                      ),
                                    },
                                    model: {
                                      value: _vm.store.onlineChatEnabled,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store,
                                          "onlineChatEnabled",
                                          $$v
                                        )
                                      },
                                      expression: "store.onlineChatEnabled",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-pix-limit",
                                      name: "onlinePaymentPixLimit",
                                      type: "text-number",
                                      currency: "R$",
                                      precision: 2,
                                      label: _vm.$t("Limite Pix"),
                                      instruction: _vm.$t(
                                        "Limite de valor para pagamento no PIX no site e no app"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.store.onlinePaymentConfig.pixLimit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "pixLimit",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.pixLimit",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-credit-limit",
                                      name: "onlinePaymentCreditLimit",
                                      type: "text-number",
                                      currency: "R$",
                                      precision: 2,
                                      label: _vm.$t("Limite Crédito"),
                                      instruction: _vm.$t(
                                        "Limite de valor para pagamento com cartão de crédito no site e no app"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.store.onlinePaymentConfig
                                          .creditLimit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "creditLimit",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.creditLimit",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-wallet-limit",
                                      name: "onlinePaymentWalletLimit",
                                      type: "text-number",
                                      currency: "R$",
                                      precision: 2,
                                      label: _vm.$t("Limite Wallet"),
                                      instruction: _vm.$t(
                                        "Limite de valor para pagamento com wallet no site e no app"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.store.onlinePaymentConfig
                                          .walletLimit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "walletLimit",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.walletLimit",
                                    },
                                  }),
                                ],
                                1
                              ),
                              false
                                ? _c(
                                    "b-col",
                                    { attrs: { md: "2" } },
                                    [
                                      _c("FormulateInput", {
                                        attrs: {
                                          id: "online-payment-cash-limit",
                                          name: "onlinePaymentCashLimit",
                                          type: "text-number",
                                          currency: "R$",
                                          precision: 2,
                                          label: _vm.$t("Limite Dinheiro"),
                                          instruction: _vm.$t(
                                            "Limite de valor para pagamento em dinheiro no site e no app"
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.store.onlinePaymentConfig
                                              .cashLimit,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.store.onlinePaymentConfig,
                                              "cashLimit",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "store.onlinePaymentConfig.cashLimit",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-liveness-enabled",
                                      name: "livenessEnabled",
                                      type: "switch",
                                      label: _vm.$t("Facial ativa"),
                                      instruction: _vm.$t(
                                        "Quando habilitado, a loja poderá utilizar reconhecimento facial para autenticação de clientes no app"
                                      ),
                                    },
                                    model: {
                                      value: _vm.store.livenessEnabled,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store,
                                          "livenessEnabled",
                                          $$v
                                        )
                                      },
                                      expression: "store.livenessEnabled",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-credit-acquirer",
                                      name: "onlinePaymentCreditAcquirer",
                                      type: "vue-select",
                                      label: _vm.$t(
                                        "Fornecedor do cartão (online)"
                                      ),
                                      placeholder: _vm.$t(
                                        "Padrão (parâmetro global)"
                                      ),
                                      options:
                                        _vm.onlinePaymentAcquirerOptions(),
                                      instruction: _vm.$t(
                                        "Quem processa o cartão de crédito no app. Vazio usa o parâmetro global; sem os dois, o cartão não é oferecido"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.store.onlinePaymentConfig
                                          .creditAcquirer,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "creditAcquirer",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.creditAcquirer",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-credit-installment",
                                      name: "onlinePaymentCreditInstallment",
                                      type: "switch",
                                      label: _vm.$t(
                                        "Crédito parcelado (online)"
                                      ),
                                      instructions: [
                                        {
                                          text: _vm.$t(
                                            "Quando habilitado, o app oferece crédito parcelado pelo estabelecimento (sem juros), somente com cartão pela Getnet."
                                          ),
                                        },
                                        {
                                          text: _vm.$t(
                                            "Também exige o pagamento parcelado habilitado na loja, uma política de parcelamento vigente e o parâmetro global ligado."
                                          ),
                                        },
                                      ],
                                    },
                                    model: {
                                      value:
                                        _vm.store.onlinePaymentConfig
                                          .creditInstallment,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "creditInstallment",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.creditInstallment",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-credit-saved-cards",
                                      name: "onlinePaymentCreditSavedCards",
                                      type: "switch",
                                      label: _vm.$t("Cartão salvo (online)"),
                                      instruction: _vm.$t(
                                        "Quando habilitado, o cliente pode salvar o cartão e pagar com ele no app. Somente com cartão pela Getnet e com o parâmetro global ligado"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.store.onlinePaymentConfig
                                          .creditSavedCards,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "creditSavedCards",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.creditSavedCards",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-credit-three-ds-required",
                                      name: "onlinePaymentCreditThreeDsRequired",
                                      type: "vue-select",
                                      disabled:
                                        _vm.store.onlinePaymentConfig
                                          .creditAcquirer === "STRIPE",
                                      label: _vm.$t("Exigir 3DS (online)"),
                                      placeholder: _vm.$t(
                                        "Padrão (parâmetro global)"
                                      ),
                                      options: _vm.threeDsRequiredOptions,
                                      instruction: _vm.$t(
                                        "Exige a autenticação do banco (3DS) no cartão pela Getnet. Vazio segue o parâmetro global; o valor da loja prevalece. Indisponível com Stripe"
                                      ),
                                    },
                                    model: {
                                      value: _vm.creditThreeDsRequiredOption,
                                      callback: function ($$v) {
                                        _vm.creditThreeDsRequiredOption = $$v
                                      },
                                      expression: "creditThreeDsRequiredOption",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-pix-biometric",
                                      name: "onlinePaymentPixBiometric",
                                      type: "switch",
                                      label: _vm.$t("Pix biometria (online)"),
                                      instruction: _vm.$t(
                                        "Quando habilitado, o app oferece o Pix por aproximação (biometria no app do banco) pela Getnet. Também exige o parâmetro global ligado"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.store.onlinePaymentConfig
                                          .pixBiometric,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "pixBiometric",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.pixBiometric",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-pix-biometric-limit",
                                      name: "onlinePaymentPixBiometricLimit",
                                      type: "text-number",
                                      currency: "R$",
                                      precision: 2,
                                      label: _vm.$t("Limite Pix biometria"),
                                      instruction: _vm.$t(
                                        "Limite de valor para o Pix biometria no app. Vazio usa o limite do Pix"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.store.onlinePaymentConfig
                                          .pixBiometricLimit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "pixBiometricLimit",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.pixBiometricLimit",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "online-payment-wallet-acquirer",
                                      name: "onlinePaymentWalletAcquirer",
                                      type: "vue-select",
                                      label: _vm.$t(
                                        "Fornecedor da wallet (online)"
                                      ),
                                      placeholder: _vm.$t("Stripe"),
                                      options:
                                        _vm.onlinePaymentAcquirerOptions(),
                                      instruction: _vm.$t(
                                        "Quem processa o Google Pay e o Apple Pay no app. Vazio é Stripe"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.store.onlinePaymentConfig
                                          .walletAcquirer,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.store.onlinePaymentConfig,
                                          "walletAcquirer",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "store.onlinePaymentConfig.walletAcquirer",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.store.onlinePaymentConfig.walletAcquirer ===
                              "GETNET"
                                ? _c(
                                    "b-col",
                                    { attrs: { md: "3" } },
                                    [
                                      _c("FormulateInput", {
                                        class: {
                                          required:
                                            _vm.store.onlinePaymentConfig
                                              .wallet,
                                        },
                                        attrs: {
                                          id: "online-payment-google-pay-gateway-merchant-id",
                                          name: "onlinePaymentGooglePayGatewayMerchantId",
                                          type: "text",
                                          maxlength: "100",
                                          validation: _vm.store
                                            .onlinePaymentConfig.wallet
                                            ? "required"
                                            : "",
                                          label: _vm.$t(
                                            "Google Pay gatewayMerchantId"
                                          ),
                                          instruction: _vm.$t(
                                            "Identificador fornecido pela Getnet para o Google Pay. Obrigatório com a wallet pela Getnet"
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.store.onlinePaymentConfig
                                              .googlePayGatewayMerchantId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.store.onlinePaymentConfig,
                                              "googlePayGatewayMerchantId",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "store.onlinePaymentConfig.googlePayGatewayMerchantId",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  name: "imageWideLocal",
                                  type: "uploader",
                                  deletable: "true",
                                  "max-files": "1",
                                  meta: false,
                                  label: _vm.$t("Imagem Wide"),
                                },
                                model: {
                                  value: _vm.imageWideLocal,
                                  callback: function ($$v) {
                                    _vm.imageWideLocal = $$v
                                  },
                                  expression: "imageWideLocal",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  name: "imageSquareLocal",
                                  type: "uploader",
                                  deletable: "true",
                                  "max-files": "1",
                                  meta: false,
                                  label: _vm.$t("Imagem Quadrada"),
                                },
                                model: {
                                  value: _vm.imageSquareLocal,
                                  callback: function ($$v) {
                                    _vm.imageSquareLocal = $$v
                                  },
                                  expression: "imageSquareLocal",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.store.type === "Bar"
                ? _c(
                    "b-tab",
                    { attrs: { title: _vm.$t("Bar") } },
                    [
                      _vm.store.type === "Bar"
                        ? _c(
                            "b-card-actions",
                            {
                              attrs: {
                                "no-actions": "",
                                "show-loading": _vm.loading || _vm.busy,
                                title: _vm.$t("Bar"),
                              },
                            },
                            [
                              _c(
                                "b-row",
                                { attrs: { md: "5" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c("FormulateInput", {
                                        attrs: {
                                          id: "waiter-comission",
                                          name: "waiterComission",
                                          type: "switch",
                                          label: _vm.$t(
                                            "Habilitar gorjeta do garçom"
                                          ),
                                          instruction: _vm.$t(
                                            "Quando habilitado, a loja do tipo Bar irá habilitar opção da gorjeta pro garçom"
                                          ),
                                        },
                                        model: {
                                          value: _vm.store.waiterComission,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.store,
                                              "waiterComission",
                                              $$v
                                            )
                                          },
                                          expression: "store.waiterComission",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.store.waiterComission,
                                      expression: "store.waiterComission",
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "5" } },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "d-flex justify-content-end mb-1",
                                          attrs: { md: "12" },
                                        },
                                        [
                                          _c("e-button", {
                                            attrs: {
                                              variant: "primary",
                                              text: _vm.$t("Adicionar gorjeta"),
                                            },
                                            on: {
                                              click: _vm.onAddWaiterComission,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "12" } },
                                        [
                                          _c("b-table", {
                                            staticClass: "bordered",
                                            attrs: {
                                              id: "stores-waiter-comission-table",
                                              responsive: "",
                                              striped: "",
                                              "show-empty": "",
                                              items:
                                                _vm.getStoreWaiterComissions,
                                              fields: _vm.waiterComissionFields,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "cell(actions)",
                                                  fn: function (row) {
                                                    return [
                                                      _c("e-grid-actions", {
                                                        attrs: {
                                                          "show-update": false,
                                                          "show-delete": true,
                                                        },
                                                        on: {
                                                          delete: function (
                                                            $event
                                                          ) {
                                                            return _vm.onRemoveWaiterComission(
                                                              row.item
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "cell(comissionFee)",
                                                  fn: function (row) {
                                                    return [
                                                      _c("FormulateInput", {
                                                        attrs: {
                                                          id:
                                                            "waiter_comission_fee-" +
                                                            row.index,
                                                          type: "text-percetage",
                                                          validation:
                                                            "number|min:0.01",
                                                          name: "comissionFee",
                                                          currency: "%",
                                                          precision: 2,
                                                          label: "",
                                                          "currency-symbol-position":
                                                            "suffix",
                                                        },
                                                        model: {
                                                          value:
                                                            row.item
                                                              .comissionFee,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              row.item,
                                                              "comissionFee",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "row.item.comissionFee",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2805503822
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("Parametrizações") } },
                [
                  _c(
                    "b-card-actions",
                    {
                      attrs: {
                        "no-actions": "",
                        "show-loading": _vm.loading || _vm.busy,
                        title: _vm.$t("Parametrizações"),
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "max_cash_amount_pay_box",
                                  name: "maxCashAmountPayBox",
                                  label: _vm.$t("Valor máx. permitido no PDV"),
                                  type: "text-number",
                                  currency: "R$",
                                  precision: 2,
                                  instructions: [
                                    {
                                      text: _vm.$t(
                                        "Valor máximo em dinheiro permitido na gaveta dos PDVs desta loja, caso o valor seja excedido a tela do caixa será bloqueado e pedirá para realizar uma sangria."
                                      ),
                                    },
                                    {
                                      text: _vm.$t(
                                        "Caso não seja informado, o valor de R$ 900 será aplicado como limite padrão."
                                      ),
                                    },
                                  ],
                                },
                                model: {
                                  value: _vm.store.maxCashAmountPayBox,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "maxCashAmountPayBox",
                                      $$v
                                    )
                                  },
                                  expression: "store.maxCashAmountPayBox",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "max_accounts_payable_value_on_pay_box",
                                  name: "maxAccountsPayableValueOnPayBox",
                                  label: _vm.$t(
                                    "Valor máx. permitido no mês para despesa no PDV"
                                  ),
                                  type: "text-number",
                                  currency: "R$",
                                  precision: 2,
                                  instructions: [
                                    {
                                      text: _vm.$t(
                                        "Valor máximo permitido do PDV para criar despesa no mês."
                                      ),
                                    },
                                    {
                                      text: _vm.$t(
                                        "Caso não seja informado, não haverá limite para criação de despesas no caixa."
                                      ),
                                    },
                                  ],
                                },
                                model: {
                                  value:
                                    _vm.store.maxAccountsPayableValueOnPayBox,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "maxAccountsPayableValueOnPayBox",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "store.maxAccountsPayableValueOnPayBox",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  instruction: _vm.$t(
                                    "Quando habilitado, impedirá a abertura do caixa se o valor digitado for maior que o saldo disponível na conta troco."
                                  ),
                                  type: "switch",
                                  label: _vm.$t("Trava na abertura de caixa"),
                                },
                                model: {
                                  value: _vm.store.lockPdvOpening,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.store, "lockPdvOpening", $$v)
                                  },
                                  expression: "store.lockPdvOpening",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "purchase_requisition_enabled",
                                  name: "purchaseRequisitionEnabled",
                                  type: "switch",
                                  label: _vm.$t(
                                    "Requisição de compra habilitada"
                                  ),
                                  instruction: _vm.$t(
                                    "Quando desabilitado, os pedidos de compra desta loja não abrirão fluxo de aprovação por falta de requisição de compra."
                                  ),
                                },
                                model: {
                                  value: _vm.store.purchaseRequisitionEnabled,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "purchaseRequisitionEnabled",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "store.purchaseRequisitionEnabled",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "purchase_requisition_generation_days",
                                  name: "purchaseRequisitionGenerationDays",
                                  type: "vue-select",
                                  label: _vm.$t(
                                    "Dias de geração das requisições de compra"
                                  ),
                                  placeholder: _vm.$t(
                                    "Selecione os dias da semana"
                                  ),
                                  options: _vm.dayOfWeekOptions(),
                                  multiple: true,
                                  instructions: [
                                    {
                                      text: _vm.$t(
                                        "Dias da semana em que as requisições de compra devem ser geradas para esta loja."
                                      ),
                                    },
                                    {
                                      text: _vm.$t(
                                        "Caso nenhum dia seja informado, nenhuma restrição de dia será aplicada."
                                      ),
                                    },
                                  ],
                                },
                                model: {
                                  value:
                                    _vm.store.purchaseRequisitionGenerationDays,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "purchaseRequisitionGenerationDays",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "store.purchaseRequisitionGenerationDays",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "installment_enabled",
                                  name: "installmentEnabled",
                                  type: "switch",
                                  label: _vm.$t(
                                    "Pagamento parcelado habilitado"
                                  ),
                                  instructions: [
                                    {
                                      text: _vm.$t(
                                        "Quando habilitado, o crédito parcelado fica disponível nesta loja conforme a política de parcelamento vigente."
                                      ),
                                    },
                                    {
                                      text: _vm.$t(
                                        "Desligado, nenhum canal oferece parcelamento — PDV, ATM ou SmartPOS — e um parcelamento que chegue por outro caminho não é registrado."
                                      ),
                                    },
                                  ],
                                },
                                model: {
                                  value: _vm.store.installmentEnabled,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "installmentEnabled",
                                      $$v
                                    )
                                  },
                                  expression: "store.installmentEnabled",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "pos_installment_enabled",
                                  name: "posInstallmentEnabled",
                                  type: "switch",
                                  disabled: !_vm.store.installmentEnabled,
                                  label: _vm.$t(
                                    "Parcelamento no POS habilitado"
                                  ),
                                  instructions: [
                                    {
                                      text: _vm.$t(
                                        "Quando habilitado, o PDV oferece as opções de parcelamento também nos pagamentos com POS desta loja."
                                      ),
                                    },
                                    {
                                      text: _vm.$t(
                                        "No POS a transação já foi feita na maquininha quando o operador informa o NSU, então o sistema não consegue recusar um parcelamento fora da política: apenas registra a divergência. No TEF a validação ocorre antes da autorização e não depende desta opção."
                                      ),
                                    },
                                  ],
                                },
                                model: {
                                  value: _vm.store.posInstallmentEnabled,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.store,
                                      "posInstallmentEnabled",
                                      $$v
                                    )
                                  },
                                  expression: "store.posInstallmentEnabled",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("FAB", {
            attrs: {
              "main-tooltip": _vm.$t("Ações"),
              "main-icon": "keyboard_command_key",
              actions: _vm.actions,
              "fixed-tooltip": true,
              busy: _vm.busy,
            },
            on: {
              save: _vm.save,
              cancel: _vm.cancel,
              active: _vm.activateDeactivateStore,
              inactive: _vm.activateDeactivateStore,
              export: _vm.exportStore,
              import: _vm.importStore,
            },
          }),
        ],
        1
      ),
      _c("delivery-location-sidebar", {
        ref: "deliveryLocationSidebar",
        on: { "add-item": _vm.onAddDeliveryLocation },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }